<template>
  <section class="tool-index mt-3">
    <h1 class="">Tools</h1>

    <div class="card animate__animated animate__fadeIn">
      <div class="card-body px-0">
        <table class="table mb-0">
          <tbody>
            <tr
              v-for="(tool, key) in tools"
              :key="key"
              @click="() => goToTool(tool)"
              :class="{ disabled: !tool.enabled }"
            >
              <td class="text-center align-middle">
                <i :class="`fa fa-2x fa-${tool.icon}`"></i>
              </td>
              <td>
                <h2 class="mb-1">
                  {{ tool.name
                  }}<sup
                    v-if="tool.new"
                    class="badge badge-solid-primary ml-2"
                    >NEW</sup
                  >
                </h2>
                <p class="mb-0">{{ tool.description }}</p>
              </td>
              <td>
                <a
                  :class="{ disabled: !tool.enabled }"
                  v-if="tool.external"
                  :href="tool.link"
                  target="_blank"
                  class="btn btn-solid-primary btn-sm w-100"
                  >GO</a
                >
                <router-link
                  :class="{ disabled: !tool.enabled }"
                  :to="tool.link"
                  v-else
                  class="btn btn-solid-primary btn-sm w-100"
                  >GO</router-link
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ToolsIndex",
  data() {
    return {
      tools: [
        {
          enabled: true,
          icon: "right-left",
          name: "Swap API",
          link: "/app/tools/swap_api",
          description: "Test the Flux Aggregator API",
          new: true,
        },
        {
          enabled: true,
          icon: "circle-plus",
          name: "v2 Token Creation",
          link: "/app/tools/token_create",
          description: "Create a v2 SPL Token with Extensions",
          new: true,
        },
        {
          enabled: true,
          icon: "circle-plus",
          name: "v1 Token Creation",
          link: "/app/tools/token_create_v1",
          description: "Create a v1 (legacy) SPL Token",
        },
        {
          enabled: true,
          icon: "water",
          name: "Pool Creation",
          link: "/app/pools/create",
          description: "Create a FluxBeam Liquidity Pool",
        },
        {
          enabled: true,
          icon: "lock",
          name: "Token Locker",
          link: "/app/tools/token_locker",
          description: "Lock Tokens for a period of time.",
        },
        {
          enabled: true,
          icon: "list",
          name: "Token Manager",
          link: "/app/tools/token_manager",
          description: "Manage token authority & updates",
        },
        {
          enabled: true,
          icon: "file",
          name: "Metadata Manager",
          link: "/app/tools/token_metadata",
          description: "Update token metadata",
        },
        {
          enabled: true,
          icon: "money-bill",
          name: "Fee Manager",
          link: "/app/tools/fee_manager",
          description: "Reclaim & View Token Fees",
        },
        {
          enabled: false,
					new: true,
          icon: "robot",
          name: "Automated Fee Manager",
          link: "/app/tools/fee_manager_automated",
          description: "Reclaim & View Token Fees Automatically",
        },
        {
          enabled: true,
          icon: "gift",
          name: "Wrap/Unwrap SOL",
          link: "/app/tools/sol_wrap",
          description: "Convert SOL to wSOL",
        },
        {
          enabled: true,
          icon: "magnifying-glass-dollar",
          name: "Withheld Amount",
          link: "/app/tools/token_withheld_amount",
          description: "View the withheld amount of tokens for a v2 mint",
        },
        {
          enabled: true,
          icon: "money-bill-transfer",
          name: "Token Transfer",
          link: "/app/tools/token_transfer",
          description: "Transfer Tokens to another wallet",
        },
        {
          enabled: true,
          icon: "fire",
          name: "Token Burn",
          link: "/app/tools/token_burn",
          description: "Burn Tokens",
        },
        {
          enabled: true,
          icon: "stamp",
          name: "Token Mint",
          link: "/app/tools/token_mint",
          description: "Mint more tokens for an existing token",
        },
        {
          enabled: true,
          icon: "envelope",
          name: "Transaction Sender",
          link: "/app/tools/transaction_send",
          description:
            "Sign & Send pre created transactions via wallet",
        },
        {
          enabled: true,
          icon: "envelopes-bulk",
          name: "Token Airdrop",
          link: "/app/tools/token_airdrop",
          description:
            "Mass Airdrop Tokens to other token holders or through manual/csv entry.",
        },
        {
          enabled: false,
          icon: "circle-check",
          name: "Token Verification",
          link: "/app/tools/token_verify",
          description: "Verify your token details on chain",
        },
        {
          enabled: false,
          icon: "arrows-rotate",
          name: "Token Migration",
          link: "/app/tools/token_migration",
          description: "Migrate v1 tokens to v2 (Token2022)",
        },
        {
          enabled: true,
          icon: "chart-line",
          name: "Token Analysis",
          link: "https://rugcheck.xyz",
          external: true,
          description: "Powered by RugCheck.xyz",
        },
      ],
    };
  },
  methods: {
    goToTool: function (tool) {
      if (!tool.enabled) return;

      if (tool.external) window.open(tool.link, "_blank");
      else this.$router.push(tool.link);
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
tr {
  vertical-align: middle;
}

tbody tr {
  cursor: pointer;
  transition: background-color 0.2s linear;
}

tr:hover {
  background: rgba(255, 255, 255, 0.3);
}

tr.disabled {
  opacity: 0.4;
}
</style>
